<template>
  <PageMain class="order-container w-100p m-center">
    <div class="fs-20 fs-b f-c-b">账户信息</div>
    <div class="bg-w flex pd-20 a-center   ">
      <div class="pr-120">
        <!-- <div v-if="accInfo" class="flex mt-10">
          <div class=" ">
            <div class=""><span class="f-c-b3 fs-24">账户余额：</span> <span class="f-c-blue fs-24" style="">{{ $utils.Big(accInfo.balance||0).plus(accInfo.frozenAmount||0).toFixed(2) }}元</span><span class="ml-20">可用余额：{{ $utils.Big(accInfo.balance||0).toFixed(2) }}元</span><span class="ml-10">(冻结{{ $utils.Big(accInfo.frozenAmount||0).toFixed(2) }}元)</span></div>

            <div><a-button type="primary" class="w-120 mt-10" @click="$router.push('/main/manager/order/recharge')">充 值</a-button></div>
          </div>

        </div> -->
        <div v-if="accInfo" class=" mt-10">
          <div class="flex a-center">
            <span class="f-c-blue fs-32 fs-b" style="">{{ $utils.Big(accInfo.balance||0).plus(accInfo.frozenAmount||0).toFixed(2) }}</span>
            <a-button class="ml-8" type="primary" @click="$router.push('/main/manager/order/recharge')">去充值</a-button>
            <!-- <a-button class="ml-8">查看明细</a-button> -->
          </div>
          <div>运费余额（元）<a-icon class="pointer" type="question-circle" @click="showTips = true" /></div>
        </div>
      </div>
      <div class="v-line" />
      <div v-if="accInfo" class=" mt-10 pr-120">
        <div class="flex a-center">
          <span class=" fs-32 fs-b" style="">{{ $utils.Big(accInfo.balance||0).toFixed(2) }}</span>
          <span class="ml-10 f-c-blue pb-10">(冻结{{ $utils.Big(accInfo.frozenAmount||0).toFixed(2) }}元)</span>
        </div>
        <div>可用余额（元）</div>
      </div>
      <div class="v-line" />
      <div v-if="accInfo" class=" mt-10 pr-20">
        <div class="flex a-center">
          <span class=" fs-32 fs-b" style="">{{ $utils.Big(accInfo.yesterdayTotalFreight||0).toFixed(2) }}</span>
        </div>
        <div>昨日消费（元）</div>
      </div>
      <!-- <div class="">
        <div class="flex mt-10">
          <div class=""><span class="f-c-b3 fs-24">昨日消费：</span> <span class="f-c-blue fs-24" style="">{{ accInfo&&accInfo.yesterdayTotalFreight||0 }}元</span></div>
        </div>

      </div> -->
    </div>
    <div class="bg-w " style="position:relative">
      <span style="z-index:12; position:absolute;left:348px;top: 14px;" class="pointer f-c-blue fs-12 ml-20" @click="couponHelpTips = true">员工如何使用电子优惠券 <a-icon type="question-circle" /></span>
      <a-tabs default-active-key="1" class="search-tab">
        <a-tab-pane key="1" tab="费用明细">
          <LeftList />
        </a-tab-pane>
        <a-tab-pane key="2" tab="费用统计" force-render>
          <RightList />
        </a-tab-pane>
        <a-tab-pane key="3" force-render>
          <span slot="tab">
            电子优惠券
          </span>

          <Coupon />
        </a-tab-pane>
      </a-tabs>
    </div>
    <FreightTips :viz.sync="showTips" />
    <CouponHelpTips :viz.sync="couponHelpTips" />
  </PageMain>
</template>
<script>

/**
 * 如何使用vue
 * 这里做最基本的用法演示，详细请看vue的官网
 * https://cn.vuejs.org/v2/guide/
 */
import LeftList from './leftList'
import RightList from './rightList'
import Coupon from './coupon'
import FreightTips from '@/components/freightTips'
import CouponHelpTips from '@/components/couponHelpTips'
export default {
  name: 'Order',
  components: {
    LeftList, RightList, Coupon, FreightTips, CouponHelpTips
  },
  data() {
    return {
      accInfo: null,
      showTips: false,
      couponHelpTips: false
      // orderGetTodayOrderCount: '',
      // orderGetTotalOrderCount: ''

    }
  },
  async created() {
    const res = await this.$http(this.$api.accountGetAccount)
    this.accInfo = res
    // this.orderGetTodayOrderCount = await this.$http(this.$api.orderGetTodayOrderCount)
    // this.orderGetTotalOrderCount = await this.$http(this.$api.orderGetTotalOrderCount)
  }
}
</script>

<style lang="scss" >
.order-container{
  .v-line{
    width: 1px ;
    height: 64px;
    background: rgba(212, 212, 212, 1);
    margin-right: 80px;
  }
}
</style>
